import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "toggle-icon",
  templateUrl: "./toggle-icon.component.html",
  styleUrls: ["./toggle-icon.component.scss"]
})
export class ToggleIconComponent implements OnInit {
  @Input()
  name: string;

  // @Input()
  // src: string;

  @Input()
  disabled:false;

  @Input()
  large:false;


  @Input("src")
  set src(value: string) {
    this._src = '/assets/icon/'+value+'.svg';
  }

  @Input()
  status: boolean = false;

  statusToColor = {
    false: "primary",
    true: "secondary"
  };

  _src:string;

  @Output() iconClicked = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onClick(event) {
    event.stopPropagation();
    if(!this.disabled){
      this.status = !this.status;
      this.iconClicked.emit(this.status);      
    }
  }
}
